import { ITournamentForm } from './form';

import { TournamentForm } from 'v2/types/TournamentModel';

export function mapFormToDto(form: ITournamentForm): TournamentForm {
  return {
    ...form,
    endDate: form.endDate?.format() ?? '',
    startDate: form.startDate?.format() ?? '',
    rewards: form.rewards,
    groupId: form.groupId || null,
    isFirstInGroup: form.groupId ? form.isFirstInGroup : undefined,
    isLastInGroup: form.groupId ? form.isLastInGroup : undefined,
  };
}
